import { render, staticRenderFns } from "./IdentityLine.vue?vue&type=template&id=33d455b2&scoped=true"
import script from "./IdentityLine.vue?vue&type=script&lang=js"
export * from "./IdentityLine.vue?vue&type=script&lang=js"
import style0 from "./IdentityLine.vue?vue&type=style&index=0&id=33d455b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d455b2",
  null
  
)

export default component.exports